var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var TDAddButton = require('./TDAddButton.jsx');
var TDDeleteButton = require('./TDDeleteButton.jsx');
var TDTextField = require('./TDTextField.jsx');
var TDCheckbox = require('./TDCheckbox.jsx');
var TDRedirect = require('./TDRedirect.jsx');

var Row = createReactClass({
	propTypes: {
		// no id means that this is a new item
		id: PropTypes.node,
		domain: PropTypes.object,
		placeholder: PropTypes.string,
		inEditMode: PropTypes.bool,
		changeHandler: PropTypes.func.isRequired
	},

	render: function() {
		let action = null;
		if (typeof this.props.id !== "undefined") {
			action = (
				<TDDeleteButton
					id={this.props.id}
					show={this.props.inEditMode}
					disabled={!this.props.inEditMode}
					onChange={this.props.changeHandler}
				/>
			);
		} else {
			action = (
				<TDAddButton
					show={this.props.inEditMode && this.props.domain.dns !== "" && JSON.stringify(this.props.domain) !== JSON.stringify(this.props.newState)}
					disabled={!this.props.inEditMode}
					onChange={this.props.changeHandler}
				/>
			);
		}

		return (
			<tr>
				<TDRedirect
					ssl={this.props.domain.ssl}
					www={this.props.domain.www}
				/>
				<TDTextField
					id={this.props.id}
					ref="textfield"
					placeholder={!this.props.id ? "Add new domain" : null}
					disabled={!this.props.inEditMode}
					type="dns"
					value={this.props.domain.dns}
					onChange={this.props.changeHandler}
				/>
				<TDCheckbox
					id={this.props.id}
					type="www"
					value={this.props.domain.www}
					disabled={!this.props.inEditMode}
					onChange={this.props.changeHandler}
				/>
				<TDCheckbox
					id={this.props.id}
					type="ssl"
					value={this.props.domain.ssl}
					disabled={!this.props.inEditMode}
					onChange={this.props.changeHandler}
				/>
				{action}
			</tr>
		);
	},

	focus: function() {
		this.refs.textfield.focus();
	}
});

module.exports = Row;
